import React, { createContext, useContext, useEffect, useState } from 'react';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import { useNavigate } from 'react-router-dom';

const OrganizationContext = createContext();

const OrganizationProvider = ({ children }) => {
    const [organizationId, setOrganizationId] = useState(null);
    const navigate = useNavigate();

    const changeOrganizationId = id => {
        setOrganizationId(id);
        localStorage.setItem('selectedOrganization', id);
    };
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        const organizationId = localStorage.getItem('selectedOrganization');
        setOrganizationId(organizationId);
    }, [isAuthenticated, navigate]);

    return (
        <OrganizationContext.Provider value={{ organizationId, changeOrganizationId }}>
            {children}
        </OrganizationContext.Provider>
    );
};

export default OrganizationProvider;

export const useOrganizationId = () => useContext(OrganizationContext).organizationId;
export const useChangeOrganizationId = () =>
    useContext(OrganizationContext).changeOrganizationId;
